import { isoCodeValidator } from '@utils/validations/constants';

export const isIsoCodeValidator = (values: string[]): number[] | true => {
  const notIsoCodes = values.flatMap((value, index) => {
    if (value === '') return []; // Skip empty values

    const codes = value.includes(',') ? value.split(',') : [value];
    const invalidCodes = codes.filter((code) => !isoCodeValidator.test(code.trim().toLowerCase()));

    return invalidCodes.length > 0 ? [index] : [];
  });

  return notIsoCodes.length > 0 ? notIsoCodes : true;
};
